// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"HSForm_formWrapper__6hjvm","title":"HSForm_title__tE761","form":"HSForm_form__IwDFR","hover":"HSForm_hover__usHle"};